import {getRegisteredGraphs} from "./graph_registry";

export const DEFAULT_DARK_GRAPH_PALETTE = [
    '#4992ff',
    '#7cffb2',
    '#fddd60',
    '#ff6e76',
    '#58d9f9',
    '#05c091',
    '#ff8a45',
    '#8d48e3',
    '#dd79ff'
];

export const DEFAULT_LIGHT_GRAPH_PALETTE = [
    '#d87c7c',
    '#919e8b',
    '#d7ab82',
    '#6e7074',
    '#61a0a8',
    '#efa18d',
    '#787464',
    '#cc7e63',
    '#724e58',
    '#4b565b'
];

export function initDayNightMode() {
    const initialize = () => {
        const darkModeSwitch = document.getElementById('darkModeSwitch');
        const dark = isDarkMode();

        applyTheme(dark);
        if (darkModeSwitch) {
            darkModeSwitch.checked = dark;
        }

        if (!darkModeSwitch || darkModeSwitch.dataset.themeBound === "true") {
            return;
        }
        darkModeSwitch.dataset.themeBound = "true";
        darkModeSwitch.addEventListener('change', () => {
            applyTheme(darkModeSwitch.checked);
            getRegisteredGraphs({ liveOnly: true }).forEach((graph) => {
                graph.reinitializeTheme(darkModeSwitch.checked ? 'dark' : 'vintage');
            });
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
        initialize();
    }
}

export function isDarkMode() {
    const currentTheme = localStorage.getItem('theme');
    if (currentTheme === null) {
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
            localStorage.setItem('theme', 'dark');
            return true;
        } else {
            localStorage.setItem('theme', 'light');
            return false;
        }
    }
    return currentTheme === 'dark';
}

export function defaultGraphPalette(dark = isDarkMode()) {
    return (dark ? DEFAULT_DARK_GRAPH_PALETTE : DEFAULT_LIGHT_GRAPH_PALETTE).slice();
}

export function ensureGraphPalette() {
    if (!Array.isArray(window.graphPalette) || window.graphPalette.length === 0) {
        window.graphPalette = defaultGraphPalette();
    }
    return window.graphPalette;
}

export function getGraphColor(index, fallback = '#6e7074') {
    const palette = ensureGraphPalette();
    if (palette.length === 0) return fallback;
    const normalizedIndex = Number.isInteger(index) && index >= 0 ? index % palette.length : 0;
    return palette[normalizedIndex];
}

function applyTheme(dark) {
    if (dark) {
        document.body.classList.add('dark-mode');
        document.documentElement.setAttribute('data-bs-theme', "dark");
        localStorage.setItem('theme', 'dark');
        window.graphPalette = DEFAULT_DARK_GRAPH_PALETTE.slice();
        return;
    }

    document.body.classList.remove('dark-mode');
    document.documentElement.setAttribute('data-bs-theme', "light");
    localStorage.setItem('theme', 'light');
    window.graphPalette = DEFAULT_LIGHT_GRAPH_PALETTE.slice();
}
